export default {
  // 自助机详情
  machineDetail: {},
  // 自助机轮播图
  machineBanner: [],
  // menu菜单
  menuData: []
};
